import React from 'react'

function EducationIcon(props) {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13 14.3333L25 7.66667L13 1L1 7.66667L13 14.3333ZM13 14.3333L21.2121 9.77101C21.9357 11.5955 22.3333 13.5846 22.3333 15.6666C22.3333 16.6017 22.2531 17.518 22.0992 18.4091C18.6191 18.7475 15.4654 20.2008 13 22.4074C10.5346 20.2009 7.38095 18.7475 3.90082 18.4091C3.74689 17.518 3.66667 16.6016 3.66667 15.6665C3.66667 13.5845 4.06433 11.5954 4.78783 9.771L13 14.3333ZM7.66667 22.3333V12.3333L13 9.37037"
        stroke="#425A85"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default EducationIcon
